import { useOrderSubmitter } from '@hooks/submitOrder/useOrderSubmitter';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupDepositConfirmedOnce } from '@tracking/trackingEvents';
import { parseValueToPennies } from '@utils/price';

const useTrackedOrderSubmit = (amount: string) => {
  const trackDepositConfirmed = useTrackSignupDepositConfirmedOnce();
  const { trackingContexts } = useTrackingContext();

  const parsedAmount = parseValueToPennies(amount);
  if (!isNaN(parsedAmount)) {
    trackDepositConfirmed(
      { amount: parsedAmount },
      { contexts: trackingContexts }
    );
  }

  const { submitAndCompleteOrder, submitOrderError, submitOrderLoading } =
    useOrderSubmitter();

  return { submitAndCompleteOrder, submitOrderError, submitOrderLoading };
};

export { useTrackedOrderSubmit };
